const mediaItems = [
  {
    thumbnail: 'https://readdy.ai/api/search-image?width=640&height=360&seq=media-thumb-01&orientation=landscape&query=A%20dark%20themed%20video%20player%20interface%20with%20warm%20orange%20play%20button%20overlay%2C%20trending%20content%20thumbnail%20with%20glowing%20labels%2C%20cinematic%20lighting%2C%16:9%20aspect%20ratio%2C%20premium%20content%20platform%20aesthetic',
    title: '51黑料最新合集 · 本周精选回顾',
    duration: '15:32',
    views: '12.8万',
    label: '热门',
    labelColor: 'primary' as const,
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20content%20display%20with%20warm%20amber%20accent%20highlights%20and%20a%20central%20play%20icon%2C%20floating%20data%20cards%20around%20the%20edges%2C%20trending%20visual%20style%2C%20cinematic%20mood%2C%2016:9%20aspect%20ratio&width=640&height=360&seq=media-thumb-02&orientation=landscape',
    title: '91黑料吃瓜速递 · 最新实况追踪',
    duration: '22:05',
    views: '10.3万',
    label: '最新',
    labelColor: 'accent' as const,
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dark%20themed%20archive%20display%20with%20layered%20content%20tiles%20and%20a%20prominent%20play%20button%20in%20warm%20orange%2C%20collection%20style%20layout%2C%20glowing%20category%20labels%2C%20editorial%20quality%2C%2016:9%20aspect%20ratio&width=640&height=360&seq=media-thumb-03&orientation=landscape',
    title: '17黑料吃瓜视频合集 · 经典回顾',
    duration: '18:47',
    views: '9.5万',
    label: '精选',
    labelColor: 'secondary' as const,
  },
];

const labelCls: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">精彩视频</h2>
          <p className="mt-2 text-sm text-foreground-600">黑料系列热门视频内容速览</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/30 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-900/20 group-hover:bg-background-900/35 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className={`absolute top-3 left-3 px-2 py-0.5 rounded text-[10px] font-bold whitespace-nowrap ${labelCls[item.labelColor]}`}>
                  {item.label}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-background-900/70 text-background-50 text-[10px] font-medium whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次浏览
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}